import { HashLink } from "react-router-hash-link";

const section = ({ part }) => {
  return (
    <div className="px-10 py-10">
      {part === 1 && (
        <>
          <h1 className="text-3xl text-center leading-tight mt-6 pb-0">
            Experience <span>🛠</span>
          </h1>
          <>
              <div className="flex flex-col-reverse xl:flex-row justify-center items-center gap-12 mt-6">
              <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
                <div className={`space-y-4 text-center`}>
                  <div className="text-left space-y-2">
                    <h1 className="text-[#000] font-semibold text-xl 2xl:text-2xl ">
                      WOLT
                    </h1>
                    <h1 className="text-primary-color font-semibold text-md 2xl:text-lg ">
                      JUNE 2026 - TO NOW
                    </h1>
                  </div>
                  <div className="text-left">
                    <p className="text-sm font-normal leading-loose opacity-60">
                        Part of the Courier Fleet team, working on DeliveryOS, a platform for managing fleet companies and couriers.
                    </p>
                    <br />
                    <HashLink
                      smooth
                      to="/experiences#exp-wolt"
                      className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
                    >
                      Read More
                    </HashLink>
                  </div>
                </div>
              </div>
              <img
                style={{ position: "relative", zIndex: 1 }}
                src="/images/1.svg"
                alt="banner"
                className="block w-[200px] bg-white m-0 p-0"
              />
            </div>
            <div className="flex flex-col xl:flex-row justify-center items-center gap-12">
            <img
              style={{ position: "relative", zIndex: 1 }}
              src="/images/6.svg"
              alt="banner"
              className="block w-[200px] bg-white m-0 p-0"
            />
            <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
              <div className={`md:pl-14 space-y-4 text-center`}>
                <div className=" text-left space-y-2">
                  <h1 className="text-[#000] font-semibold text-xl 2xl:text-2xl ">
                    MINDERA
                  </h1>
                  <h1 className="text-primary-color font-semibold text-md 2xl:text-lg ">
                    NOVEMBER 2022 - JUNE 2026
                  </h1>
                </div>
                <div className="text-left">
                  <p className="text-sm font-normal leading-loose opacity-60">
                   Mindera partners with global clients to build large-scale
                      digital products across sectors like telecommunications,
                      retail and IoT.
                  </p>
                  <br />
                  <HashLink
                    smooth
                    to="/experiences#exp-mindera"
                    className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
                  >
                    Read More
                  </HashLink>
                </div>
              </div>
            </div>
            </div>


          </>
        </>
      )}
      {part === 2 && (
        <>
          <div className="flex flex-col-reverse xl:flex-row justify-center items-center gap-12 mt-4">
            <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
              <div className={`space-y-4 text-center`}>
                <div className="text-left space-y-2">
                  <h1 className="text-[#000] font-semibold text-xl 2xl:text-2xl ">
                    RIVER-DONE DIGITAL
                  </h1>
                  <h1 className="text-primary-color font-semibold text-md 2xl:text-lg ">
                    MAY 2022 - NOVEMBER 2022
                  </h1>
                </div>
                <div className="text-left">
                  <p className="text-sm font-normal leading-loose opacity-60">
                    RiverDone Digital delivers custom digital products for
                      clients in Web3, fintech, and SaaS industries.
                  </p>
                  <br />
                  <HashLink
                    smooth
                    to="/experiences#exp-riverdone"
                    className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
                  >
                    Read More
                  </HashLink>
                </div>
              </div>
            </div>
            <img
              style={{ position: "relative", zIndex: 1 }}
              src="/images/3.svg"
              alt="banner"
              className="block w-[200px] bg-white m-0 p-0"
            />
          </div>
          <div className="flex flex-col xl:flex-row justify-center items-center gap-12">
            <img
              style={{ position: "relative", zIndex: 1 }}
              src="/images/6.svg"
              alt="banner"
              className="block w-[200px] bg-white m-0 p-0"
            />
            <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
              <div className={`md:pl-14 space-y-4 text-center`}>
                <div className=" text-left space-y-2">
                  <h1 className="text-[#000] font-semibold text-xl 2xl:text-2xl ">
                    NU TERRA LABS
                  </h1>
                  <h1 className="text-primary-color font-semibold text-md 2xl:text-lg ">
                    FEBRUARY 2022 - MAY 2022
                  </h1>
                </div>
                <div className="text-left">
                  <p className="text-sm font-normal leading-loose opacity-60">
                    Nu Terra Labs provides digital marketing and technology
                    solutions in the agriculture sector.
                  </p>
                  <br />
                  <HashLink
                    smooth
                    to="/experiences#exp-nuterralabs"
                    className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
                  >
                    Read More
                  </HashLink>
                </div>
              </div>
            </div>
          </div>

        </>
      )}
      {part === 3 && (
        <>
          <div className="flex flex-col-reverse xl:flex-row justify-center items-center gap-12 mt-4">
            <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
              <div className={`space-y-4 text-center`}>
                <div className="text-left space-y-2">
                  <h1 className="text-[#000] font-semibold text-xl 2xl:text-2xl ">
                    SMARTINIA
                  </h1>
                  <h1 className="text-primary-color font-semibold text-md 2xl:text-lg ">
                    FEBRUARY 2021 - FEBRUARY 2022
                  </h1>
                </div>
                <div className="text-left">
                  <p className="text-sm font-normal leading-loose opacity-60">
                    Smartinia builds SaaS products in e-commerce, e-learning,
                    and logistics.
                  </p>
                  <br />
                  <HashLink
                    smooth
                    to="/experiences#exp-smartinia"
                    className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
                  >
                    Read More
                  </HashLink>
                </div>
              </div>
            </div>
            <img
              style={{ position: "relative", zIndex: 1 }}
              src="/images/4.svg"
              alt="banner"
              className="block w-[200px] bg-white m-0 p-0"
            />
          </div>

          <div className="flex flex-col xl:flex-row justify-center items-center gap-12">
            <img
              style={{ position: "relative", zIndex: 1 }}
              src="/images/5.svg"
              alt="banner"
              className="block w-[200px] bg-white m-0 p-0"
            />
            <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
              <div className={`md:pl-14 space-y-4 text-center`}>
                <div className="text-left space-y-2">
                  <h1 className="text-[#000] font-semibold text-xl 2xl:text-2xl ">
                    FASTY DELIVERY
                  </h1>
                  <h1 className="text-primary-color font-semibold text-md 2xl:text-lg ">
                    AUGUST 2019 - AUGUST 2020
                  </h1>
                </div>
                <div className="text-left">
                  <p className="text-sm font-normal leading-loose opacity-60">
                    Fasty is a food delivery platform connecting local
                    restaurants with customers.
                  </p>
                  <br />
                  <HashLink
                    smooth
                    to="/experiences#exp-fasty"
                    className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
                  >
                    Read More
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default section;
